'use strict';

module.exports = FormData;



//////////////////
// WEBPACK FOOTER
// ./node_modules/axios/lib/platform/browser/classes/FormData.js
// module id = HqR1
// module chunks = 142